<template>
  <v-container class="pb-3 pa-0">
    <v-card flat="">
      <div class="d-flex align-center">
        <v-file-input
          small-chips
          hint="Image must be a .png .jpeg .gif or .bmp and smaller than 1MB"
          persistent-hint
          multiple
          label="Images to Upload"
          :show-size="1000"
          accept="image/*"
          ref="imageupload"
          @change="previewFiles"
        ></v-file-input>
        <v-spacer />
        <v-btn
          depressed
          color="blue white--text"
          @click="uploadImages"
          :disabled="files.length == 0"
        >
          <v-icon left dark>mdi-image</v-icon>
          Upload
        </v-btn>
      </div>
      <v-card-subtitle class="pa-0 pl-8 pt-2 red--text" v-if="error"
        >Could not upload this image, please make sure that it was a png, jpeg,
        or bmp image</v-card-subtitle
      >
    </v-card>
  </v-container>
</template>

<script>
import service from "@/services/index.js";
export default {
  data: () => ({
    files: [],
    error: false
  }),
  methods: {
    removeImage(index) {
      this.images.splice(index, 1);
    },
    async uploadImages() {
      this.error = false;
      try {
        this.$store.commit("setLoading", true);

        await service.image.upload({ images: this.files });

        this.$store.commit("setLoading", false);
        this.$emit("success");
      } catch (err) {
        this.error = true;
        this.$store.commit("setLoading", false);

        console.error("[IMAGE]", "Error", err);
      }
    },
    previewFiles(e) {
      this.files = e;
    }
  }
};
</script>

<style></style>
